import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { ASNDialog } from 'src/modules/supply_chain/components/ASNDialog'
import { skuit } from 'src/services/skuit'

import { ASNListTable } from 'src/components/Table/list/ASN'
import { ListPage } from 'src/components/Pages/ListPage'

export const ASNListPage = () => {
  const paginator = useQueryPaginator('asn-list', skuit.sc.asn.list)

  const exportFields = [
    'bill_of_lading_number',
    'canceled_on',
    'carrier_guid',
    'carrier_name',
    'client_guid',
    'client_name',
    'facility_address',
    'facility_guid',
    'facility_name',
    'guid',
    'internal_notes',
    'is_transload',
    'received_on',
    'status',
    'tracking_number',
  ]

  return (
    <ListPage
      title="Advanced Shipping Notices"
      paginator={paginator}
      dialogs={[{ title: 'New ASN', Dialog: ASNDialog }]}
    >
      <ASNListTable
        paginator={paginator}
        fields={[
          'trackingNumber',
          'client',
          'consignee',
          'facility',
          'carrier',
          'status',
          'transloadNumber',
          'appointment',
          'estimatedArrivalDate',
          'dates',
        ]}
        bulkActions={['printASN', 'printTransloadPlacard', 'printAll']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.asn.export,
        }}
      />
    </ListPage>
  )
}
